export default "__VITE_ASSET__D4_wWT5W__"